import { render, staticRenderFns } from "./HeaderWarehouseReport.vue?vue&type=template&id=18aaf42c&scoped=true&"
import script from "./HeaderWarehouseReport.vue?vue&type=script&lang=js&"
export * from "./HeaderWarehouseReport.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWarehouseReport.vue?vue&type=style&index=0&id=18aaf42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aaf42c",
  null
  
)

export default component.exports